import { defineStore } from 'pinia';
import { generateUUID } from '@/modules/uuid';
import { logger } from '@/logging/logger';

interface RegistrationState {
  registrationId: string | null;
  hrId: string | null;
}

export const useRegistrationStore = defineStore('registration', {
  persist: true,
  state: (): RegistrationState => ({
    registrationId: null,
    hrId: null,
  }),

  actions: {
    async register(): Promise<void> {
      if (!this.registrationId) {
        this.registrationId = generateUUID();
      }

      if (!this.hrId) {
        try {
          let response = await fetch('api/v3/register');
          if (response.ok) {
            const results = await response.json();
            this.hrId = results.hrId;
          }
        }
        catch (e) {
          logger.warn('network', 'registration.hrid.miss', undefined, 'HR ID failed to set')
        }
      }
    }
  }
})